import { BING_TRAFFIC_KEY } from '@constants'

import { safeStorageGet } from './safeStorage'

export const isBingTraffic = (search = window.location.search) =>
  new URLSearchParams(search).has('msclkid') || safeStorageGet(BING_TRAFFIC_KEY) === '1'
